// Lib
import React, { ReactElement } from 'react';
import { noop } from 'lodash';
import { useDispatch } from 'react-redux';

// Hooks
import useCardTiptapEditorExtensions from '../../card/tiptap/useCardTiptapEditorExtensions';
import useClientElementTiptapEditor from '../../../components/tiptapEditor/useClientElementTiptapEditor';

// Types
import { EditorContent } from '@tiptap/react';
import { TiptapContent } from '../../../../common/tiptap/tiptapTypes';
import { useTranslator, type TranslationFunction } from '../../../components/i18n/useTranslator';

// Styles
import './DocumentDetailViewTiptapEditor.scss';

type DocumentDetailViewTiptapEditorProps = {
    textContent: TiptapContent;
    editorId: string;
    editorKey: string;
};

const DocumentDetailViewTiptapEditor = (props: DocumentDetailViewTiptapEditorProps): ReactElement => {
    const { textContent, editorId, editorKey } = props;

    const dispatch = useDispatch();
    const translate = useTranslator('elements', 'elementTypes.document') as TranslationFunction;

    const extensions = useCardTiptapEditorExtensions({
        dispatch,
        saveContent: noop,
        universalCardConversion: false,
        translate,
    });

    const { editor } = useClientElementTiptapEditor({
        persistedContent: textContent,
        extensions,

        editorId,
        editorKey,

        isEditable: false,
        isEditing: false,
        isSingleSelected: false,
    });

    return (
        <div className="DocumentDetailViewTiptapEditorContainer">
            <EditorContent className="DocumentDetailViewTiptapEditor" dir="auto" editor={editor} />
        </div>
    );
};

export default DocumentDetailViewTiptapEditor;
